/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/location';
import './address_validation_error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "Address": {
                "fields": {
                  "firstName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "address": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 3,
                    "rule": "optional"
                  },
                  "addressValidationError": {
                    "type": "squareup.solidshop.model.AddressValidationError",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE Address @ squareup/solidshop/model/address.proto at 13:1
 */
export const Address = $root.lookupType('squareup.solidshop.model.Address');
fixType(Address);
Builder.createAndAttachToType(Address);
